import React from 'react';

import { HighlightedPolygonsWrapper } from 'pages/document/page/components/Polygons/highlightedPolygons/StyledComponent';
import HighlightedPolygon from 'pages/document/page/components/Polygons/highlightedPolygons/highlightedPolygon';

function HighlightedPolygons({ polygons, getStyledPolygon }) {
  // polygons is Map and must be converted to an array with preserved unique keys
  return (
    <HighlightedPolygonsWrapper>
      {polygons.entrySeq().map(([key, polygon]) => (
        <HighlightedPolygon key={key} polygon={polygon} style={getStyledPolygon(polygon)} />
      ))}
    </HighlightedPolygonsWrapper>
  );
}

HighlightedPolygons.displayName = 'HighlightedPolygons';
export default HighlightedPolygons;
